<template>
  <el-dialog
    v-model="visible"
    title="导入"
    width="30%"
    :z-index="1000"
    :close-on-click-modal="false"
    @close="fileList = []"
  >
    <el-button
      type="primary"
      link
      style="margin-bottom: 10px"
      @click="templateDownload()"
      >下载模板</el-button
    >
    <el-upload
      ref="upload"
      drag
      action=""
      accept=".xls, .xlsx"
      :auto-upload="false"
      :limit="1"
      :on-exceed="handleExceed"
      v-model:file-list="fileList"
    >
      <el-icon class="el-icon--upload"><upload-filled /></el-icon>
      <div class="el-upload__text">拖入文件或 <em>点击上传</em></div>
      <template #tip>
        <div class="el-upload__tip">
          只能上传 xls/xlsx 格式文件且文件大小不超过10M
        </div>
      </template>
    </el-upload>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          v-loading="buttonLoading"
          :disabled="fileList.length == 0"
        >
          上传
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ElMessage, genFileId } from "element-plus";
import { ref } from "vue";
import { postDownload } from "@/utils";

const emits = defineEmits(["afterUpload"]);

const props = defineProps({
  fn: {
    type: Function,
    default: () => {},
  },
  uploadConfig: {
    type: Object,
    default: () => {
      // templateUrl:  模板下载的url
      // name :  模板文件名
    },
  },
});

// 弹窗控制
const visible = ref(false);

// 文件上传ref
const upload = ref(null);

// 文件列表
const fileList = ref([]);

// 按钮loading
const buttonLoading = ref(false);

// 覆盖前一个文件
const handleExceed = (files) => {
  upload.value?.clearFiles();
  const file = files[0];
  file.uid = genFileId();
  upload.value?.handleStart(file);
};

// 弹窗打开  传入上传文件的函数
const handleDialogOpen = () => {
  visible.value = true;
};

// 点击保存
const handleSubmit = () => {
  buttonLoading.value = true;
  let fileBody = new FormData();
  fileBody.append("file", fileList.value[0].raw);
  props
    .fn(fileBody)
    .then((res) => {
      if (res.code == "2000") {
        ElMessage.success("导入成功");
        visible.value = false;
        emits("afterUpload");
      }
    })
    .finally(() => {
      buttonLoading.value = false;
    });
};

// 模板下载
const templateDownload = () => {
  postDownload(props.uploadConfig.templateUrl, {}, props.uploadConfig.name);
};

defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
